export default{
    methods:{
        charsOnly(input) {
            return input.replace(/[^A-Za-z]+/g, '')
        },
    },
    filters: {
        truncate: function(text, length, clamp) {
            clamp = clamp || '...'
            var node = document.createElement('div')
            node.innerHTML = text
            var content = node.textContent
            return content.length > length
                ? content.slice(0, length) + clamp
                : content
        },
        mixThousandSeparatorFormat: function(value) {
            if (value == 0) return value
            if (!value || isNaN(value)) return
            const formatter = new Intl.NumberFormat('es')
            return  formatter.format(value)
        },
    },
}
